import type { IAuditoriaAcaoItem, IAuditoriaTipoEvento } from "@/api/space/dtos/authenticator.dto";

// ------------------------------- CONSTANTS -------------------------------
export const AUDITORIA_TIPO_LABELS: Readonly<Record<IAuditoriaTipoEvento, string>> = {
	salvar_acessos_grupo_usuario: "Alteração de acessos",
	clonar_grupo_usuario: "Clonagem de grupo",
};

export const AUDITORIA_ACAO_LABELS: Readonly<Record<IAuditoriaAcaoItem, string>> = {
	inserido: "Inserido",
	ativado: "Ativado",
	desativado: "Desativado",
	inalterado: "Inalterado",
};
